export default function (retailCodebaseSplitFlag = false) {
    return function (nextState, _replace, callback) {
        const { pathname, query = {} } = nextState.location;

        if (!retailCodebaseSplitFlag || query.suppressRetailRedirect) {
            callback();
            return;
        }
        const matches = pathname.match(/^\/(drive|assortment|assortments|merchant|merchants)/i);
        if (matches && matches.length > 0) {
            window.location.href = window.location.href.replace(`/${matches[1]}`, `/plan/${matches[1]}`);
            return;
        }

        callback();
    };
}
